module.exports = __webpack_public_path__ + "img/success.37c6455f.svg";